import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Sparkles, Globe, BookOpen } from 'lucide-react';
export function SeoContentSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 24
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="py-24 px-4 relative z-10 bg-dark-bg" data-id="element-141">
      <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-pink-primary/[0.03] rounded-full blur-[120px] pointer-events-none" data-id="element-142" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-143">
        <motion.div className="text-center mb-16" initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-80px'
      }} variants={containerVariants} data-id="element-144">
          <motion.h2 variants={itemVariants} className="text-3xl md:text-5xl font-bold mb-4" data-id="element-145">
            新加坡<span className="text-pink-primary neon-glow" data-id="element-146">芽笼</span>
            夜生活指南
          </motion.h2>
          <motion.div variants={itemVariants} className="w-24 h-1 bg-pink-primary mx-auto rounded-full mb-4" data-id="element-147" />
          <motion.p variants={itemVariants} className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-148">
            Singapore Geylang Nightlife &amp; Escort Companion Guide
          </motion.p>
        </motion.div>

        <motion.div className="space-y-12" initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} variants={containerVariants} data-id="element-149">
          {/* Article Block 1 */}
          <motion.div variants={itemVariants} className="bg-dark-card rounded-2xl p-8 md:p-10 border border-white/5" data-id="element-150">
            <div className="flex items-center gap-3 mb-6" data-id="element-151">
              <div className="w-10 h-10 rounded-full bg-pink-primary/10 flex items-center justify-center text-pink-primary" data-id="element-152">
                <MapPin size={20} data-id="element-153" />
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-white" data-id="element-154">
                芽笼 — 新加坡夜生活的心脏地带
              </h3>
            </div>
            <div className="space-y-4 text-gray-300 leading-relaxed" data-id="element-155">
              <p data-id="element-156">
                芽笼（Geylang）是新加坡最具传奇色彩的街区之一，位于新加坡市中心东部，以其丰富多彩的夜生活、地道美食和多元文化闻名于世。作为新加坡唯一合法的红灯区，芽笼吸引着来自世界各地的游客和本地居民，是体验新加坡夜间文化不可错过的目的地。
              </p>
              <p data-id="element-157">
                芽笼地区分为多个巷弄（Lorong），每条巷弄都有其独特的氛围和特色。从传统的榴莲摊位到深夜营业的田鸡粥餐厅，从热闹的KTV到各类娱乐场所，芽笼的夜晚永远充满活力。芽笼777（Geylang777）正是扎根于这片充满魅力的土地，为您提供最全面、最可靠的新加坡伴游服务资讯。
              </p>
              <p data-id="element-158">
                无论您是初次造访新加坡的旅客，还是长期居住的本地居民，芽笼777都能为您提供专业的指引和推荐。我们熟悉芽笼每一条街巷的特色，了解新加坡夜生活的每一个细节，致力于成为您探索新加坡夜间娱乐的最佳伙伴。
              </p>
            </div>
          </motion.div>

          {/* Article Block 2 */}
          <motion.div variants={itemVariants} className="bg-dark-card rounded-2xl p-8 md:p-10 border border-white/5" data-id="element-159">
            <div className="flex items-center gap-3 mb-6" data-id="element-160">
              <div className="w-10 h-10 rounded-full bg-pink-primary/10 flex items-center justify-center text-pink-primary" data-id="element-161">
                <Sparkles size={20} data-id="element-162" />
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-white" data-id="element-163">
                新加坡伴游服务行业概览
              </h3>
            </div>
            <div className="space-y-4 text-gray-300 leading-relaxed" data-id="element-164">
              <p data-id="element-165">
                新加坡作为亚洲四小龙之一和全球金融中心，每年吸引数百万商务旅客和游客。随着国际交流的日益频繁，高端伴游服务（Escort
                Service）在新加坡已发展成为一个成熟的行业。从商务陪同、社交活动到私人约会，专业的伴游服务为客户提供了高品质的陪伴体验。
              </p>
              <p data-id="element-166">
                新加坡的伴游行业以其高度的专业化和规范化著称。优质的伴游平台如芽笼777（geylang777.net），通过严格的筛选机制和认证体系，确保每一位伴游都具备良好的素质和专业的服务态度。平台汇聚了来自中国大陆、台湾、越南、泰国、马来西亚、日本、韩国、菲律宾等亚洲各国的优质伴游，满足不同客户的多元化需求。
              </p>
              <p data-id="element-167">
                在新加坡寻找伴游服务时，选择一个可靠的信息平台至关重要。芽笼777凭借多年的行业经验、庞大的用户基础和完善的服务体系，已成为新加坡伴游信息领域的标杆品牌。我们与多家知名平台保持良好的合作关系，包括TTVIP、新加坡后宫网（SGHarem）、新加坡寂寞男人（SGLonelyGuy）、新加坡美丽城堡（SGBeautyCastle）、幸福缘（xfy1.net）、新加坡爽吧（Shiok8）以及新加坡是您网（isyou.net）等，共同为客户打造最优质的服务生态。
              </p>
            </div>
          </motion.div>

          {/* Article Block 3 */}
          <motion.div variants={itemVariants} className="bg-dark-card rounded-2xl p-8 md:p-10 border border-white/5" data-id="element-168">
            <div className="flex items-center gap-3 mb-6" data-id="element-169">
              <div className="w-10 h-10 rounded-full bg-pink-primary/10 flex items-center justify-center text-pink-primary" data-id="element-170">
                <Globe size={20} data-id="element-171" />
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-white" data-id="element-172">
                多元化的伴游选择 — 亚洲各国佳丽汇聚狮城
              </h3>
            </div>
            <div className="space-y-4 text-gray-300 leading-relaxed" data-id="element-173">
              <p data-id="element-174">
                芽笼777平台最大的优势之一，便是为客户提供来自亚洲各国的多元化伴游选择。新加坡独特的地理位置和国际化环境，使其成为亚洲各国佳丽汇聚的理想之地。在芽笼777，您可以找到：
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 my-6" data-id="element-175">
                {[{
                country: '🇨🇳 中国佳丽',
                desc: '温婉大方，知书达理，擅长社交陪伴，是商务宴请的理想选择'
              }, {
                country: '🇻🇳 越南佳丽',
                desc: '清纯甜美，温柔体贴，以真诚的服务态度赢得众多客户青睐'
              }, {
                country: '🇹🇭 泰国佳丽',
                desc: '热情开朗，善解人意，独特的异域风情令人难忘'
              }, {
                country: '🇲🇾 马来西亚佳丽',
                desc: '多元文化背景，精通多国语言，沟通无障碍'
              }, {
                country: '🇯🇵 日本佳丽',
                desc: '优雅精致，注重细节，提供极致的日式服务体验'
              }, {
                country: '🇰🇷 韩国佳丽',
                desc: '时尚靓丽，气质出众，深受追求品质客户的喜爱'
              }].map((item, i) => <div key={i} className="bg-[#0A0A0F] rounded-xl p-4 border border-white/5" data-id="element-176">
                    <p className="font-bold text-white mb-1" data-id="element-177">{item.country}</p>
                    <p className="text-sm text-gray-400" data-id="element-178">{item.desc}</p>
                  </div>)}
              </div>
              <p data-id="element-179">
                每一位入驻芽笼777平台的伴游，都经过严格的身份核实、照片认证和背景审查。我们与TTVIP等顶级合作伙伴共享认证标准，确保信息的真实性和可靠性。同时，新加坡后宫网（SGHarem）和新加坡美丽城堡（SGBeautyCastle）等友站也为客户提供了更多的选择和参考。
              </p>
            </div>
          </motion.div>

          {/* Article Block 4 */}
          <motion.div variants={itemVariants} className="bg-dark-card rounded-2xl p-8 md:p-10 border border-white/5" data-id="element-180">
            <div className="flex items-center gap-3 mb-6" data-id="element-181">
              <div className="w-10 h-10 rounded-full bg-pink-primary/10 flex items-center justify-center text-pink-primary" data-id="element-182">
                <BookOpen size={20} data-id="element-183" />
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-white" data-id="element-184">
                新加坡伴游服务贴士与注意事项
              </h3>
            </div>
            <div className="space-y-4 text-gray-300 leading-relaxed" data-id="element-185">
              <p data-id="element-186">
                对于初次在新加坡寻找伴游服务的客户，芽笼777为您整理了以下实用建议，帮助您获得安全、愉快的体验：
              </p>
              <div className="space-y-3 my-6" data-id="element-187">
                {['选择信誉良好的平台：优先选择芽笼777、TTVIP、幸福缘（xfy1.net）等经过市场验证的知名平台，避免通过不明渠道获取信息。', '核实伴游信息：通过平台提供的认证标识确认伴游身份的真实性，芽笼777的所有认证伴游均带有专属认证徽章。', '保护个人隐私：使用平台推荐的安全通讯方式，如Telegram加密聊天。芽笼777官方Telegram频道（t.me/gl777net）是获取最新资讯的最安全渠道。', '了解服务内容与价格：在预约前充分了解服务项目和收费标准，芽笼777倡导透明定价，杜绝隐性消费。新加坡爽吧（Shiok8）和新加坡是您网（isyou.net）等友站也提供价格参考。', '尊重伴游：保持礼貌和尊重，遵守双方约定的服务内容和时间，共同营造愉快的体验氛围。', '遵守当地法律：了解并遵守新加坡相关法律法规，确保所有活动在合法范围内进行。'].map((tip, i) => <div key={i} className="flex gap-3 items-start" data-id="element-188">
                    <span className="flex-shrink-0 w-6 h-6 rounded-full bg-pink-primary/20 text-pink-primary text-xs font-bold flex items-center justify-center mt-0.5" data-id="element-189">
                      {i + 1}
                    </span>
                    <p className="text-sm" data-id="element-190">{tip}</p>
                  </div>)}
              </div>
              <p data-id="element-191">
                新加坡寂寞男人（SGLonelyGuy）社区的众多用户也推荐芽笼777作为首选的伴游信息平台。无论您身在新加坡何处，芽笼777都能为您提供最贴心、最专业的服务指引。
              </p>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}